export default __webpack_public_path__ + "static/media/bar_code.95d83469.svg";